import {
  applyMiddleware,
  combineReducers,
  compose,
  legacy_createStore,
} from "redux";
import thunk from "redux-thunk";
import { IApplicationState, reducers } from "./root-reducer";
import authorizationMiddleware from "./auth-middleware";
import { refreshTokenMiddleware } from "./refresh-token-middleware";

export default function configureStore(initialState?: IApplicationState) {
  const middleware = [refreshTokenMiddleware, authorizationMiddleware, thunk];

  const rootReducer = combineReducers({
    ...reducers,
  });

  const enhancers = [];
  const windowIfDefined =
    typeof window === "undefined" ? null : (window as any);
  if (windowIfDefined && windowIfDefined.__REDUX_DEVTOOLS_EXTENSION__) {
    enhancers.push(windowIfDefined.__REDUX_DEVTOOLS_EXTENSION__());
  }

  return legacy_createStore(
    rootReducer,
    initialState,
    compose(applyMiddleware(...middleware), ...enhancers)
  );
}
